import * as React from 'react';
import SecondaryToolbar from '../common/SecondaryToolbar';
import IconButton from '../common/IconButton';
import { ToolbarDirection } from '../../actions/UIModeAction';
import { connect } from 'react-redux';
import { Dispatch, Action } from 'redux';
import { clearEverything } from '../../drawing/actions/DrawingAction';

interface TextboxSecondaryLevelProps {
  readonly direction: ToolbarDirection;
  readonly dispatch: Dispatch<Action>;
}

const confirmClearEverything = (dispatch: Dispatch<Action>) => {
  if (window.confirm('このページの書き込みをすべて削除します。本当によろしいですか？')) {
    dispatch(clearEverything());
  }
};

const TextboxSecondaryLevel: React.SFC<
  TextboxSecondaryLevelProps
> = React.memo((props) => {
  return (
    <SecondaryToolbar direction={props.direction}>
      <IconButton
        title="全消去"
        imagePath="images/tool-icons/new/trashbox_all/trashbox_all"
        rouondRect={true}
        onClick={() => confirmClearEverything(props.dispatch)}
      />
    </SecondaryToolbar>
  );
});

export default connect()(TextboxSecondaryLevel);
